import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class NewsletterContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getFormulario(id: string): Observable<any> {
    return this.getFormularioContents(id).pipe(
      map(res =>
        this.buildReponseFormularioObject(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryFormularioContents[0].data;
  }

  private getFormularioContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryFormularioContents(filter: "id eq '${id}'") {
          data {
            nome {
              iv
            }
            titulo {
              iv
            }
            email {
              iv
            }
            descricaoBotao {
              iv
            }
            assuntoMensagem {
              iv
            }
            corpoMensagem {
              iv
            }
            corDeFundo {
              iv
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildReponseFormularioObject(form: any) {
    return {
      description: form.titulo.iv,
      email: form.email.iv,
      subject: form.assuntoMensagem ? form.assuntoMensagem.iv : null,
      body: form.corpoMensagem
        ? encodeURIComponent(form.corpoMensagem.iv)
        : null,
      isPrimary: form.corDeFundo ? form.corDeFundo.iv : form.corDeFundo
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
